import { api } from '@api'
import { Contact } from './types/contactTypes'
import { usePaginate } from './usePaginate'
import { FetchParams, PaginatedResponse } from './types'

const fetchContacts = async (params?: FetchParams): Promise<PaginatedResponse<Contact>> => {
  const queryParams = new URLSearchParams()
  
  if (params?.scope) {
    queryParams.append('scope', params.scope)
  }
  if (params?.search) {
    queryParams.append('search', params.search)
  }
  if (params?.noGhost) {
    queryParams.append('noGhost', 'true')
  }
  if (params?.onlyGhost) {
    queryParams.append('onlyGhost', 'true')
  }
  if (params?.filters) {
    queryParams.append('filters', JSON.stringify(params.filters))
  }
  if (params?.pageParam) {
    queryParams.append('page', params.pageParam.toString())
  }
  if (params?.limit) {
    queryParams.append('limit', params.limit.toString())
  }

  const url = `/contacts${queryParams.toString() ? `?${queryParams.toString()}` : ''}`
  const { data } = await api.get<PaginatedResponse<Contact>>(url)
  return data
}

export const usePaginateContacts = (params?: FetchParams) => {
  return usePaginate<Contact>('contacts', fetchContacts, params)
}
